import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const ImageToPDF = () => {
  const [wasmLoaded, setWasmLoaded] = useState(false);

  // Load the Go WASM module
  useEffect(() => {
    const go = new window.Go();

    WebAssembly.instantiateStreaming(fetch('/main.wasm'), go.importObject)
      .then((result) => {
        go.run(result.instance);
        setWasmLoaded(true);
      })
      .catch((err) => {
        console.error('Error loading WASM:', err);
      });
  }, []);

  // Function to handle dropped files
  const onDrop = async (acceptedFiles) => {
    if (!wasmLoaded || !window.convertImagesToPDF) {
      alert('WASM not yet loaded. Please wait a moment.');
      return;
    }

    // Convert image files to base64 strings
    const imagePromises = acceptedFiles.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result); // base64 encoded string
        };
        reader.readAsDataURL(file);
      });
    });

    const imageDataArray = await Promise.all(imagePromises);

    try {
      // Call the WASM Go function (returns Uint8Array)
      const pdfBytes = window.convertImagesToPDF(imageDataArray);

      // Create a blob from Uint8Array
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      // Trigger download
      const a = document.createElement('a');
      a.href = url;
      a.download = 'converted.pdf';
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error generating PDF:', err);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'image/*',
    multiple: true
  });

  return (
    <div {...getRootProps()} style={styles.dropzone}>
      <input {...getInputProps()} />
      <p>Drag & drop some images here, or click to select files</p>
    </div>
  );
};

const styles = {
  dropzone: {
    border: '2px dashed #aaa',
    borderRadius: '10px',
    padding: '40px',
    textAlign: 'center',
    marginTop: '20px'
  }
};

export default ImageToPDF;
